export default __webpack_public_path__ + "static/media/pencilSVG.c085038d.svg";